// --- UUID (Universally Unique Identifiers) utility functions

export { default as generateUUID } from "./generateUUID.js"
export { default, default as generateShortUUID } from "./generateShortUUID.js"